<!-- 
<div class="enrollment-reports-container col-md-12 no-padding">
    <div id="enrollmentReport">
        <div class="row no-margin">
            <div class="col-md-12 no-padding">
                <div id="icons-container" class="row float-right paddingtop-10">
                    <div class="col-md-12 no-padding">
                        <div class="col-md-3 right-padding-0 align-print-icon">
                            <button type="button" tabindex="0" (keyup.enter)="exportFile('print')" (click)="exportFile('print')"
                                class="iconButtons no-margin" [disabled]="isAllEnrollmentReportLoading || isLoading">
                                <span class="btn-label">
                                    <img class="excel-image" [src]="printIconUrl" alt="{{'customer-service.Print' |translate |translateKey }}"
                                        title="{{'customer-service.Print' |translate |translateKey }}" />
                                </span>
                            </button>
                        </div>        
                        <div class="col-md-3 right-padding-0">
                            <button type="button" tabindex="0" (keyup.enter)="exportFile('csv')" (click)="exportFile('csv')"
                                class="iconButtons no-margin" [disabled]="isAllEnrollmentReportLoading || isLoading">
                                <span class="btn-label">
                                    <img class="excel-image" [src]="excelIconUrl"
                                        alt="{{'reports.Export CSV' |translate |translateKey}}"
                                        title="{{'reports.Export CSV' |translate |translateKey}}"/>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 no-padding mt-10 mb-10">
            <div class="table-responsive">
                <table class="table-sm table-hover table-bordered" width="100%">
                    <thead>
                        <tr>
                            <th class="cursor-pointer">{{'enrollment-reports.First Name' |translate |translateKey  }} &nbsp;</th>
                            <th class="cursor-pointer">{{'enrollment-reports.Last Name' |translate |translateKey  }} &nbsp;</th>
                            <th class="cursor-pointer">{{'enrollment-reports.FBO ID' |translate |translateKey  }}&nbsp;</th>
                            <th class="cursor-pointer">{{'enrollment-reports.Enrollment Date' |translate |translateKey  }}&nbsp;</th>
                            <th class="cursor-pointer">{{'enrollment-reports.Member Type' |translate |translateKey  }} &nbsp;</th>
                            <th class="cursor-pointer">{{'enrollment-reports.Home Country' |translate |translateKey  }} &nbsp;</th>
                            <th class="cursor-pointer">{{'enrollment-reports.Email Address' |translate |translateKey  }} &nbsp;</th>
                            <th class="cursor-pointer">{{'enrollment-reports.ERP Timestamp' |translate |translateKey  }}&nbsp;</th>
                            <th class="cursor-pointer">{{'enrollment-reports.ERP Response Status' |translate |translateKey  }}&nbsp;</th>
                            <th class="cursor-pointer">{{'enrollment-reports.AS400 Timestamp' |translate |translateKey  }}&nbsp;</th>
                            <th class="cursor-pointer">{{'enrollment-reports.AS400 Response Status' |translate |translateKey  }}&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody
                        *ngIf="!isLoading && enrollmentReport && enrollmentReport.length > 0">
                        <tr
                            *ngFor="let report of enrollmentReport | paginate: {  id: 'enrollment-reports-pagination', itemsPerPage: pageSize, currentPage: pageNumber, totalItems: pageCount }">
                           
                            <td>{{report.firstName? (report.firstName): 'N/A'}}</td>
                            <td>{{report.lastName? (report.lastName): 'N/A'}}</td>
                            <td>{{report.fboId? (report.fboId): 'N/A'}}</td>
                            <td>{{report.enrollmentDate? (report.enrollmentDate): 'N/A'}}</td>
                            <td>{{report.memberType? (report.memberType): 'N/A'}}</td>
                            <td>{{report.homeCountry? (report.homeCountry): 'N/A'}}</td>
                            <td>{{report.emailAddress? (report.emailAddress): 'N/A'}}</td>
                            <td>{{report.erpTimeStamp? (report.erpTimeStamp): 'N/A'}}</td>
                            <td>{{report.erpResponseStatus? (report.erpResponseStatus): 'N/A'}}</td>
                            <td>{{report.as400TimeStamp? (report.as400TimeStamp): 'N/A'}}</td>
                            <td>{{report.as400ResponseStatus? (report.as400ResponseStatus): 'N/A'}}</td>
                        </tr>
                    </tbody>
                    <tbody
                        *ngIf="(!isLoading && (enrollmentReport && enrollmentReport.length === 0)) || (isResponseError && !isLoading)">
                        <tr>
                            <td colspan="29"  class="text-center ">{{'customer-service.No record(s) found' |translate | translateKey}}.</td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="isLoading">
                        <tr>
                            <td colspan="29" class="text-center">{{'customer-service.Loading Results, Please wait.'|translate | translateKey}}.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="mt-5 paddingbot-20"
                *ngIf="enrollmentReport && enrollmentReport.length > 0">
                <span>{{pageCount}} {{'customer-service.record(s) found' |translate |translateKey}}</span>
                <pagination-controls [id]="paginationInstance.id" (pageChange)="pageChange($event)" class="pull-right">
                </pagination-controls>
            </div>
        </div>
        <div class="col-md-12 padding-lr-0 paddingbot-20">
            <div class="col-md-4 padding-lr-0">
                <select class="form-control per-page-width" id="currentPageSize" [(ngModel)]="pageSize"
                    [disabled]="!(enrollmentReport && enrollmentReport.length > 0)"
                    (change)="pageSizeChange($event.target.value)" name="currentPageSize" #currentPageSize="ngModel">
                    <option *ngFor="let pageSize of pageSizes" [value]="pageSize">{{pageSize}}</option>
                </select>
            </div>
        </div>
    </div>
</div> -->
<div class="row w-100 no-margin message paddingtop-20"
    *ngIf="(!isLoading && (enrollmentReport && enrollmentReport.length === 0)) || (isResponseError && !isLoading)">
    <div class="w-100 messageContent text-center">
        <strong class="">{{'customer-service.No record(s) found' |translate | translateKey}}.</strong>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/reports/enrollment-reports.component.html